import axios from 'axios';
import { logWarn, log } from '../utils/log';

const fasttrackVersion = (window && window.fasttrackVersion) ? window.fasttrackVersion : 'local';

export const loginWithAuthToken = (authToken, fusionUrl, source) => {
  log(`loginWithAuthToken, sid: [${authToken}], source: [${source}]`);

  const headers = { authtoken: authToken };
  if (source) {
    headers.source = source;
  } else {
    logWarn('loginWithAuthToken, source is not set');
  }

  return axios.post(`${fusionUrl}/Platform/LoginAuthToken`, {}, { params: { ftv: fasttrackVersion }, headers });
};

export const loginWithJWTToken = (authToken, fusionUrl, source = null) => {
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  if (source) headers.source = source;

  return axios.post(`${fusionUrl}/Platform/LoginJWTToken`, {}, { params: { ftv: fasttrackVersion }, headers });
};

export const tokenLogin = (enableJWT, authToken, fusionUrl, source) => {
  if (enableJWT) {
    return loginWithJWTToken(authToken, fusionUrl, source);
  }

  return loginWithAuthToken(authToken, fusionUrl, source);
};
